<template>
  <div class="user-table">
    <a-table
      sticky
      size="small"
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="dataSource"
      :scroll="{ x: 1100 }"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template
        #customFilterDropdown="{
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }"
      >
        <div style="padding: 8px">
          <a-input
            ref="searchInput"
            :placeholder="$t('placeholder.search')"
            :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block"
            @change="
              (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
            "
            @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
          />
          <a-button
            type="primary"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
          >
            <template #icon><SearchOutlined></SearchOutlined></template>
            {{ $t("placeholder.search") }}
          </a-button>
          <a-button
            size="small"
            style="width: 90px"
            @click="handleReset(clearFilters)"
          >
            {{ $t("button.reset") }}
          </a-button>
        </div>
      </template>
      <template #customFilterIcon="{ filtered, column }">
        <search-outlined
          v-if="
            column.dataIndex === 'num_act' ||
            column.dataIndex === 'num_1c' ||
            column.dataIndex === 'managerId' ||
            column.dataIndex === 'reciever'
          "
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <filter-outlined
          v-else
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'cityId'">
          <span>{{ record.cityId === 1 ? "Almaty" : "Astana" }}</span>
        </template>
        <template v-if="column.dataIndex === 'managerId'">
          {{ $store.getters.getManagerById(record.managerId) }}
        </template>
        <template v-if="column.dataIndex === 'depId'">
          {{ depName(record.num_act.match(/[a-zA-Z]/)[0], "by_short") }}
        </template>
        <template v-if="column.dataIndex === 'masterId' && !record.masterId">
          {{ $t("table.notSpecified") }}
        </template>
        <template
          v-if="column.dataIndex === 'coord_date' && !record.coord_date"
        >
          {{ $t("table.notSpecified") }}
        </template>
        <template
          v-else-if="
            column.dataIndex === 'coord_date' && record.orderStatusId !== 8
          "
        >
          <span style="white-space: nowrap">{{ record.coord_date }}</span
          ><br />
          <span :style="' color:' + getDateDiff(record.coord_date)[1]">
            {{ getDateDiff(record.coord_date)[0] }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'reciever'">
          <span style="white-space: nowrap">{{ record.reciever }}</span>
        </template>
        <template v-else-if="column.dataIndex === 'masterId'">
          {{ $store.getters.getMasterById(record.masterId) }}
        </template>
        <template v-if="column.dataIndex === 'orderStatusId'">
          <OrderStatus :order="record" />
        </template>
        <template v-if="column.dataIndex === 'word'">
          <a :href="config.API_HOST + 'word/' + record.word" target="_blank"
            >{{ record.word }}
          </a>
        </template>
        <template v-else-if="column.dataIndex === 'excel'">
          <a
            :href="config.API_HOST + 'excel/' + record.excel"
            target="_blank"
            >{{ record.excel }}</a
          >
        </template>
        <template v-if="column.dataIndex == 'num_act' && record.by_agreement">
          <span>{{ record.num_act }}</span>
          <span
            :style="
              'color:' +
              colors.light.dark +
              ';background:' +
              colors.light.secondary +
              ';padding: 1px; border-radius:2px;'
            "
            >{{ getPayById(record.paid_type) }}</span
          >
        </template>
        <template v-if="column.dataIndex === 'action'">
          <svg
            class="pointer"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="confirm(record.id)"
          >
            <g clip-path="url(#clip0_1_263)">
              <path
                d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM18 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4Z"
                fill="#ff0000"
                fill-opacity="1"
              />
            </g>
            <defs>
              <clipPath id="clip0_1_263">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
import { usePagination } from "vue-request";
import { computed, defineComponent, createVNode, h, reactive } from "vue";
import {
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons-vue";
import axios from "axios";
import config from "../../../config.js";
import store from "@/store/index";
import { Modal } from "ant-design-vue";
import columns from "@/utils/orders/orderAdminCols";
import colors from "@/utils/colors";
import OrderStatus from "./OrderStatus.vue";
import getDateDiff from "@/utils/getDateDiff";
import getPayById from "@/utils/getPayById";
import depName from "@/utils/getDepartmentNameById";
import i18n from "@/i18n/i18n";
const { t } = i18n.global;

const queryData = (params) => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
  };

  return axios.get(config.API_URL + "api/order/", {
    params,
    headers,
  });
};
export default defineComponent({
  components: {
    OrderStatus,
    SearchOutlined,
    FilterOutlined,
  },
  setup() {
    const state = reactive({
      searchText: "",
      searchedColumn: "",
    });
    const confirm = (orderId) => {
      Modal.confirm({
        title: t("modal.deletingOrder"),
        icon: createVNode(ExclamationCircleOutlined),
        content: t("modal.wantDeleteOrder"),
        okText: t("modal.yes"),
        cancelText: t("modal.cancel"),
        onOk() {
          deleteOrder(orderId);
        },
      });
    };
    const success = () => {
      Modal.success({
        title: t("modal.success"),
        content: h("p", t("modal.userSuccessDeleted")),
      });
    };
    const error = (errorText) => {
      Modal.error({
        title: t("modal.error"),
        content: errorText,
      });
    };
    const deleteOrder = async (orderId) => {
      store.commit("setIsLoading", true);
      try {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${window.localStorage.getItem("jwt")}`;
        await axios.delete(config.API_URL + "api/order/" + orderId).then(() => {
          success();
          refresh();
        });
      } catch (e) {
        console.log(e);
        error(e.message);
      }
      store.commit("setIsLoading", false);
    };
    const { data, run, loading, current, pageSize, refresh } = usePagination(
      queryData,
      {
        formatResult: (res) => res.data.orders,
        pagination: {
          currentKey: "page",
          pageSizeKey: "limit",
          totalKey: "data",
        },
      }
    );
    const dataSource = computed(() => data.value?.rows || []);
    const pagination = computed(() => ({
      total: data.value?.count || store.state.totalOrders,
      current: current.value,
      pageSize: pageSize.value,
    }));
    const handleTableChange = (pag, filters, sorter) => {
      store.commit("setOrderFilters", filters);
      run({
        limit: pag.pageSize,
        page: pag?.current,
        sortBy: sorter.field,
        sortType: sorter.order === "descend" || !sorter.field ? "DESC" : "ASC",
        ...filters,
      });
    };
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      state.searchText = selectedKeys[0];
      state.searchedColumn = dataIndex;
    };
    const handleReset = (clearFilters) => {
      clearFilters({
        confirm: true,
      });
      state.searchText = "";
    };
    return {
      dataSource,
      pagination,
      loading,
      columns,
      handleTableChange,
      confirm,
      refresh,
      config,
      colors,
      QuestionCircleOutlined,
      getDateDiff,
      getPayById,
      handleSearch,
      handleReset,
      depName
    };
  },
  computed: {
    orderCount() {
      return store.state.totalOrders;
    },
  },
  watch: {
    orderCount() {
      this.refresh();
    },
  },
});
</script>
